import { render, staticRenderFns } from "./Contestants.vue?vue&type=template&id=1a605118&scoped=true&"
import script from "./Contestants.vue?vue&type=script&lang=js&"
export * from "./Contestants.vue?vue&type=script&lang=js&"
import style0 from "./Contestants.vue?vue&type=style&index=0&id=1a605118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a605118",
  null
  
)

export default component.exports